class LayoutSwitcher extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('button[data-layout-mode]');
    this.grid = document.querySelector('#ProductGridContainer #product-grid');
  }
  connectedCallback() {
    this.init();
  }
  init() {
    if (!this.grid || !this.buttons.length) return;
    this.buttons.forEach(button => {
      button.addEventListener('click', this.onClick.bind(this));
    });
  }
  onClick(event) {
    const button = event.currentTarget;
    const mode = button.dataset.layoutMode;
    this.updateActiveButton(button);
    this.applyLayout(mode);
  }
  updateActiveButton(activeButton) {
    this.buttons.forEach(btn => btn.classList.remove('btn--active'));
    activeButton.classList.add('btn--active');
  }
  applyLayout(mode) {
    switch (mode) {
      case 'grid--1-col-tablet-down':
        this.removeGridClasses();
        this.grid.classList.add('grid--1-col-tablet-down');
        break;
      case 'grid--2-col-tablet-down':
        this.removeGridClasses();
        this.grid.classList.add('grid--2-col-tablet-down');
        break;
      case 'grid--3-col-tablet-down':
        // No reemplaza, solo añade
        this.grid.classList.add('grid--3-col-tablet-down');
        break;
    }
  }
  removeGridClasses() {
    this.grid.classList.remove(
      'grid--1-col-tablet-down',
      'grid--2-col-tablet-down',
      'grid--3-col-tablet-down'
    );
  }
}
customElements.define('layout-switcher', LayoutSwitcher);